module.exports = __webpack_public_path__ + "593a3d53/img/cadBim.e369a02a.png";